import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs';
import { AppSettings } from '../common/app.settings';
import 'rxjs/add/operator/map';
import { VoteLocation } from '../models/vote.location.model'
import { ApiResult } from '../models/apiresult.model';
import { ContentHeaders } from '../common/headers';

@Injectable()
export class VoteLocationService {
    private apiController = '/VoteLocation';

    constructor(
        private http: Http,
        private contentHeaders: ContentHeaders) {
    }

    getVoteLocations(): Promise<VoteLocation[]> {
        // get users from api
        return this.http.get(AppSettings.apiEndPoint + this.apiController + '/GetVoteLocations', { headers: this.contentHeaders.headers })
            .map((response: Response) => {
                return response.json();
            })
            .toPromise()
            .catch(this.handleErrorPromise);
    }

    get(voteLocationId: string): Promise<VoteLocation> {
        return this.http.get(
            AppSettings.apiEndPoint + this.apiController + '/' + voteLocationId,
            { headers: this.contentHeaders.headers }
            )
            .map((response: Response) => response.json())
            .toPromise()
            .catch(this.handleErrorPromise);
    }

    update(voteLocation: VoteLocation): Promise<ApiResult> {
        return this.http.put(
            AppSettings.apiEndPoint + this.apiController + '/' + voteLocation.id,
                JSON.stringify(voteLocation),
                { headers: this.contentHeaders.headers }
            )
            .map((response: Response) => response.json())
            .toPromise()
            .catch(this.handleErrorPromise);
    }

    add(voteLocation: VoteLocation): Promise<ApiResult> {
        return this.http.post(
            AppSettings.apiEndPoint + this.apiController + '/',
                JSON.stringify(voteLocation),
                { headers: this.contentHeaders.headers }
            )
            .map((response: Response) => response.json())
            .toPromise()
            .catch(this.handleErrorPromise);
    }

    delete(voteLocationId: string): Promise<ApiResult> {
        return this.http.delete(
            AppSettings.apiEndPoint + this.apiController + '/' + voteLocationId,
            { headers: this.contentHeaders.headers }
            )
            .map((response: Response) => response.json())
            .toPromise()
            .catch(this.handleErrorPromise);
    }

    private handleErrorPromise(error: any): Promise<void> {
        try {
            error = JSON.parse(error._body);
        } catch (e) {
        }

        const errMsg = error.errorMessage
            ? error.errorMessage
            : error.message
            ? error.message
            : error._body
            ? error._body
            : error.status
            ? `${error.status} - ${error.statusText}`
            : 'unknown server error';

        console.error(errMsg);
        return Promise.reject(errMsg);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/vote.location.service.ts